import { ReactComponent as ActionIcon } from '@/assets/icons/screenplay/action.svg'
import { ReactComponent as CharacterIcon } from '@/assets/icons/screenplay/character.svg'
import { ReactComponent as SceneIcon } from '@/assets/icons/screenplay/scene.svg'
import { ReactComponent as ShotIcon } from '@/assets/icons/screenplay/shot.svg'
import { ReactComponent as TransitionIcon } from '@/assets/icons/screenplay/transition.svg'
import { FC, SVGProps } from 'react'
import { NodeType } from '../editor/nodes/NodeCore'

export type ElementTypeUnion = `${NodeType}`

export type V2SElementType =
    | Exclude<ElementTypeUnion, 'page-break' | 'character' | 'parans' | 'dialogue'>
    | 'character-block'
export type V2SElementTypeMeta = {
    //shortcut: string[]
    label: string
    icon: FC<SVGProps<SVGSVGElement>>
    helpText: string
    ex: string
}
export const v2SElementTypeMetaData: Record<V2SElementType, V2SElementTypeMeta> = {
    [NodeType.Scene]: {
        label: 'Scene',
        icon: SceneIcon,
        helpText:
            "Use this to start a new scene. Mention whether it's INT. (interior) or EXT. (exterior), the location, and the time of day (DAY/NIGHT).",
        ex: 'Scene: Interior, John’s apartment, day.',
    },
    [NodeType.Action]: {
        label: 'Action',
        icon: ActionIcon,
        helpText:
            'Describe what’s happening visually in the scene. Keep it present tense and concise.',
        ex: 'Action: John paces nervously across the room, checking his phone every few seconds.',
    },
    ['character-block']: {
        label: 'Character Block ',
        icon: CharacterIcon,
        helpText:
            "Used when a character speaks. Begin with the character's name, optionally add how the line is delivered (parenthetical), then the actual dialogue.",
        ex: 'Character: Sarah. Parenthetical: whispering. Dialogue: I don’t think we’re alone.',
    },
    [NodeType.Transition]: {
        label: 'Transition',
        icon: TransitionIcon,
        helpText:
            'This describes how the scene transitions. Usually aligned to the right, e.g., CUT TO:, FADE IN:, FADE OUT:.',
        ex: 'Transition: Cut to.',
    },
    [NodeType.Shot]: {
        label: 'Shot',
        icon: ShotIcon,
        helpText: 'Use this to indicate a camera shot. Useful for directors and cinematographers.',
        ex: 'Shot: Close-up of Sarah’s eyes widening in fear.',
    },
}
